import React from 'react';
import { Lightbulb } from 'lucide-react';

const OpportunitiesTab = ({ analysis }) => {
    return (
        <div>
            <h2 className="text-xl font-bold mb-4">Opportunità di Contenuto</h2>

            <div className="space-y-6">
                {/* PAA Not Covered */}
                <div className="bg-yellow-50 border-l-4 border-yellow-400 p-4 rounded">
                    <h3 className="font-semibold mb-3 flex items-center gap-2 text-yellow-800">
                        <Lightbulb size={18} />
                        Domande PAA Non Coperte ({analysis.contentOpportunities.paaNotCovered.length})
                    </h3>
                    {analysis.contentOpportunities.paaNotCovered.length > 0 ? (
                        <>
                            <p className="text-sm text-gray-700 mb-3">
                                Queste domande appaiono in "People Also Ask" ma non sono ben coperte dai primi 5 risultati organici.
                                Opportunità per creare contenuto mirato.
                            </p>
                            <ul className="space-y-2">
                                {analysis.contentOpportunities.paaNotCovered.map((q, i) => (
                                    <li key={i} className="text-sm bg-white p-2 rounded border-l-2 border-yellow-400">
                                        <span className="font-medium text-yellow-700">Q{i + 1}:</span> {q}
                                    </li>
                                ))}
                            </ul>
                            <div className="mt-3 p-3 bg-yellow-100 rounded text-sm">
                                <strong>Azione:</strong> Crea contenuto che risponda specificamente a queste domande,
                                usando le domande come H2 o sottosezioni della pagina.
                            </div>
                        </>
                    ) : (
                        <p className="text-sm text-gray-600">
                            Ottimo! I risultati organici coprono già le principali domande PAA.
                        </p>
                    )}
                </div>

                {/* Refinement Chips Opportunities */}
                {analysis.contentOpportunities.refinementGaps.length > 0 && (
                    <div className="bg-blue-50 border-l-4 border-blue-400 p-4 rounded">
                        <h3 className="font-semibold mb-3 text-blue-800">
                            Filtri di Ricerca Suggeriti da Google ({analysis.contentOpportunities.refinementGaps.length})
                        </h3>
                        <p className="text-sm text-gray-700 mb-3">
                            Google suggerisce questi filtri agli utenti. Considera di creare pagine ottimizzate per queste varianti.
                        </p>
                        <div className="flex flex-wrap gap-2 mb-3">
                            {analysis.contentOpportunities.refinementGaps.map((chip, i) => (
                                <span key={i} className="bg-blue-200 text-blue-900 px-3 py-1 rounded-full text-sm font-medium">
                                    {chip}
                                </span>
                            ))}
                        </div>
                        <div className="mt-3 p-3 bg-blue-100 rounded text-sm">
                            <strong>Azione:</strong> Crea pagine di categoria o filtri per questi attributi (brand, tipo, caratteristiche).
                        </div>
                    </div>
                )}

                {/* Related Search Gaps */}
                {analysis.contentOpportunities.relatedSearchGaps.length > 0 && (
                    <div className="bg-green-50 border-l-4 border-green-400 p-4 rounded">
                        <h3 className="font-semibold mb-3 text-green-800">
                            Ricerche Correlate Non Servite ({analysis.contentOpportunities.relatedSearchGaps.length})
                        </h3>
                        <p className="text-sm text-gray-700 mb-3">
                            Queste ricerche correlate non sembrano ben coperte dai top 5 risultati. Quick win potenziali.
                        </p>
                        <ul className="space-y-2">
                            {analysis.contentOpportunities.relatedSearchGaps.map((search, i) => (
                                <li key={i} className="text-sm bg-white p-2 rounded flex items-center gap-2">
                                    <span className="text-green-600">🔍</span>
                                    <span>{search}</span>
                                </li>
                            ))}
                        </ul>
                        <div className="mt-3 p-3 bg-green-100 rounded text-sm">
                            <strong>Azione:</strong> Valuta di creare contenuto per queste long-tail keyword o aggiungi sezioni nella pagina principale.
                        </div>
                    </div>
                )}

                {/* Missing Formats */}
                <div className="bg-purple-50 border-l-4 border-purple-400 p-4 rounded">
                    <h3 className="font-semibold mb-3 text-purple-800">
                        Formati di Contenuto Mancanti
                    </h3>
                    <div className="grid grid-cols-2 gap-4">
                        <div className={`p-3 rounded ${!analysis.contentOpportunities.missingFormats.video ? 'bg-gray-200' : 'bg-white border-2 border-purple-300'}`}>
                            <div className="font-medium text-sm mb-1">Video</div>
                            {analysis.contentOpportunities.missingFormats.video ? (
                                <div className="text-xs text-purple-700">
                                    ✓ Opportunità! Nessun video in SERP. Crea contenuto video per differenziarti.
                                </div>
                            ) : (
                                <div className="text-xs text-gray-600">
                                    Video già presenti in SERP
                                </div>
                            )}
                        </div>
                        <div className={`p-3 rounded ${!analysis.contentOpportunities.missingFormats.images ? 'bg-gray-200' : 'bg-white border-2 border-purple-300'}`}>
                            <div className="font-medium text-sm mb-1">Immagini</div>
                            {analysis.contentOpportunities.missingFormats.images ? (
                                <div className="text-xs text-purple-700">
                                    ✓ Opportunità! Nessun box immagini. Ottimizza le immagini per apparire.
                                </div>
                            ) : (
                                <div className="text-xs text-gray-600">
                                    Box immagini già presente
                                </div>
                            )}
                        </div>
                    </div>
                </div>

                {/* Summary */}
                <div className="bg-gray-100 p-4 rounded-lg">
                    <h3 className="font-semibold mb-2">Riepilogo Opportunità</h3>
                    <div className="text-sm text-gray-700 space-y-1">
                        <p>• <strong>{analysis.contentOpportunities.paaNotCovered.length}</strong> domande PAA da targetizzare</p>
                        <p>• <strong>{analysis.contentOpportunities.refinementGaps.length}</strong> filtri/varianti suggeriti da Google</p>
                        <p>• <strong>{analysis.contentOpportunities.relatedSearchGaps.length}</strong> ricerche correlate non servite</p>
                        <p>• <strong>
                            {(analysis.contentOpportunities.missingFormats.video ? 1 : 0) +
                                (analysis.contentOpportunities.missingFormats.images ? 1 : 0)}
                        </strong> formati di contenuto mancanti</p>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default OpportunitiesTab;
